import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import {
  Body1Strong as BoldText,
} from '@fluentui/react-components';

import { useGetStyledAssetStatus } from '../utils/use-get-styled-asset-status';
import { Asset } from '../utils/types';
import { usePopoverStyles } from '../styles/popover-styles';

interface AssetPerformancePopoverProps {
  i18n: any;
  asset: Asset;
}

export function AssetPerformancePopoverWithConversions({ i18n, asset }: AssetPerformancePopoverProps) {
  const styles = usePopoverStyles();
  const getStyledAssetStatus = useGetStyledAssetStatus(i18n);

  return (
    <div className={classNames('asset-perf-card-popover', styles.container)}>
      <div className={styles.title}>
        <BoldText className="title" align="start">{i18n.getString(_TL_('Asset details'))}</BoldText>
      </div>
      <div className={classNames('perf-editorial-row', styles.perfEditorialRow)}>
        {getStyledAssetStatus(asset)}
      </div>
      <div className={classNames('conversions-row', styles.row)}>
        <p className="conversions-title">{i18n.getString(_TL_('Conversions'))}</p>
        <BoldText className="conversions-value">{_.isNumber(asset.PerformanceMetrics.ConversionsCredit) ? asset.PerformanceMetrics.ConversionsCredit : '--'}</BoldText>
      </div>
      <div className={classNames('revenue-row', styles.row)}>
        <p className="revenue-title">{i18n.getString(_TL_('Revenue'))}</p>
        <BoldText className="revenue-value">{_.isNumber(asset.PerformanceMetrics.AdvertiserReportedRevenue) ? asset.PerformanceMetrics.AdvertiserReportedRevenue : '--'}</BoldText>
      </div>
      <div className={classNames('impressions-row', styles.row)}>
        <p className="impressions-title">{i18n.getString(_TL_('Impressions'))}</p>
        <BoldText className="impressions-value">{_.isNumber(asset.PerformanceMetrics.Impressions) ? asset.PerformanceMetrics.Impressions : '--'}</BoldText>
      </div>
      <div className={classNames('clicks-row', styles.row)}>
        <p className="clicks-title">{i18n.getString(_TL_('Clicks'))}</p>
        <BoldText className="clicks-value">{_.isNumber(asset.PerformanceMetrics.Clicks) ? asset.PerformanceMetrics.Clicks : '--'}</BoldText>
      </div>
    </div>
  );
}
